import { render, staticRenderFns } from "./TooltipTrigger.vue?vue&type=template&id=4bffa02a&"
import script from "./TooltipTrigger.vue?vue&type=script&lang=js&"
export * from "./TooltipTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports